"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Calendar = _interopRequireDefault(require("../../Calendar"));

var _constant = require("../constant");

var _calendarWrapper = _interopRequireDefault(require("./calendarWrapper.prototypes"));
/* eslint-disable prefer-destructuring */


var CalendarWrapper = function CalendarWrapper(props) {
  var theme = props.theme,
      viewport = props.viewport,
      disableOneWay = props.disableOneWay,
      calendarWrapperOutput = props.calendarWrapperOutput,
      labelDepart = props.labelDepart,
      labelReturn = props.labelReturn,
      translations = props.translations,
      calendarModalOpen = props.calendarModalOpen,
      callbackOpenCalendarModal = props.callbackOpenCalendarModal,
      dateFormatData = props.dateFormatData,
      calendarProps = props.calendarProps,
      prefillDefaultDepart = props.prefillDefaultDepart,
      prefillDefaultReturn = props.prefillDefaultReturn,
      preFillTripType = props.preFillTripType,
      maxDays = props.maxDays;
  var resetLabel = translations.data[0].calendarResetButton;
  var confirmLabel = translations.data[0].calendarSubmitButton;
  var lowestFareLabel = translations.data[0].lowestFareLabel;
  var noFareLabel = translations.data[0].noFareLabel;
  var lowestFareLabelOneWay = translations.data[0].lowestFareLabelOneWay;
  var lowestFareLabelDepart = translations.data[0].lowestFareLabelDepart;
  var lowestFareLabelReturn = translations.data[0].lowestFareLabelReturn;

  var calendarOutputHandler = function calendarOutputHandler(res) {
    calendarWrapperOutput(res);
  };

  return /*#__PURE__*/_react.default.createElement(_Calendar.default, (0, _extends2.default)({
    theme: theme,
    disableOneway: disableOneWay,
    labelDepart: labelDepart,
    labelReturn: labelReturn,
    dateFormatData: dateFormatData || _constant.DATAFORMAT_DATA,
    maxDays: maxDays,
    calendarOutputdata: calendarOutputHandler,
    viewType: viewport,
    resetLabel: resetLabel,
    confirmLabel: confirmLabel,
    customProperties: {
      id: 'fsw-calendar'
    },
    openCalendarModal: calendarModalOpen,
    callbackOpenCalendarModal: callbackOpenCalendarModal,
    lowestFareLabel: lowestFareLabel,
    noFareLabel: noFareLabel
  }, calendarProps, {
    prefillDefaultDepart: prefillDefaultDepart,
    prefillDefaultReturn: prefillDefaultReturn,
    preFillTripType: preFillTripType,
    lowestFareLabelOneWay: lowestFareLabelOneWay,
    lowestFareLabelDepart: lowestFareLabelDepart,
    lowestFareLabelReturn: lowestFareLabelReturn
  }));
};

CalendarWrapper.propTypes = _calendarWrapper.default.PropTypes;
CalendarWrapper.defaultProps = _calendarWrapper.default.DefaultProps;
var _default = CalendarWrapper;
exports.default = _default;